import { render, staticRenderFns } from "./behavioralsource.vue?vue&type=template&id=7654ea84&scoped=true"
import script from "./behavioralsource.vue?vue&type=script&lang=js"
export * from "./behavioralsource.vue?vue&type=script&lang=js"
import style0 from "./behavioralsource.vue?vue&type=style&index=0&id=7654ea84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7654ea84",
  null
  
)

export default component.exports